import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import AddDataButton from 'components/AddDataButton'
import { isSuperUser } from 'utils/Auth'

import ModalAddEdit from './ModalAddEdit'

const ServiceSubCategory = props => (
  <div className="row">
    <div className="col-md-12">
      <div className="portlet light portlet-fit">
        <div className="portlet-title">
          <div className="caption">
            <span className="caption-subject sbold uppercase">Service Sub-Category List</span>
          </div>
          <div className="actions">
            <AddDataButton
              actions={props.openModalFormat(true)}
              label="+ Add new sub-category"
            />
          </div>
        </div>
        <div className="portlet-body">
          <div className="table-scrollable table-scrollable-borderless">
            <table className="table table-hover table-light">
              <thead>
                <tr className="uppercase">
                  <th> # </th>
                  <th> CREATED AT </th>
                  <th> SUB-CATEGORY NAME </th>
                  <th> SUB-CATEGORY PARENT </th>
                  {isSuperUser(props.user) && (
                    <th className="table-actions"> Action </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {props.formatList.rows.map((format, index) => (
                  <tr key={format.id}>
                    <td>{
                      (index + 1) +
                      ((props.formatList.currentPage - 1) * props.formatList.qs.limit)
                    }
                    </td>
                    <td>{moment(format.createdAt).format('MMMM, DD YYYY')}</td>
                    <td>{format.name}</td>
                    <td>{format.service.name}</td>
                    <td>
                      {isSuperUser(props.user) && (
                        <button
                          className="material-icons pointer-type"
                          onClick={props.onEditClick(format)}
                        >
                          edit
                        </button>
                      )}
                      {isSuperUser(props.user) && (
                        <button
                          className="material-icons pointer-type"
                          onClick={props.setIsDeleteSubCategoryModalOpen(true, format.id)}
                        >
                          delete
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="portlet-footer">
          <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={<a href="">...</a>}
            breakClassName={'break-me'}
            pageCount={props.formatList.totalPages}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            onPageChange={props.handlePageChange}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={props.formatList.currentPage - 1}
          />
        </div>
      </div>
    </div>
    <ModalAddEdit
      isModalOpen={props.isModalFormatOpen}
      openModalFormat={props.openModalFormat}
      serviceSelections={props.serviceSelections}
      setInputDataAdd={props.setInputDataFormat}
      data={props.inputData}
      onClickConfirm={props.isEditFormat ? props.updateDataFormat : props.addNewDataFormat}
      title={props.isEditFormat ? 'Edit Sub-category' : 'Add Sub-category'}
      isEditFormat={props.isEditFormat}
    />
  </div>
)

ServiceSubCategory.propTypes = {
  formatList: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
    totalPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  handlePageChange: PropTypes.func.isRequired,
  openModalFormat: PropTypes.func.isRequired,
  isModalFormatOpen: PropTypes.bool.isRequired,
  serviceSelections: PropTypes.arrayOf(PropTypes.object).isRequired,
  setInputDataFormat: PropTypes.func.isRequired,
  inputData: PropTypes.shape({}).isRequired,
  addNewDataFormat: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  isEditFormat: PropTypes.bool.isRequired,
  updateDataFormat: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  setIsDeleteSubCategoryModalOpen: PropTypes.func.isRequired,
}

export default ServiceSubCategory
